import * as React from 'react';
import { Grid, Col, Row } from 'react-flexbox-grid';
import { Card } from 'material-ui';
import { get } from 'lodash';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { pcrIdentificationTypeEnum } from './_eventsEnums';

const ExternalLookupDetail: React.SFC<any> = ({ identificationNumber, type, series, notValidFrom = 'validní' }) => (
  <Card style={{ padding: '15px', margin: '15px 0' }}>
    <Row>
      {[
        { label: 'Číslo dokladu', value: identificationNumber },
        { label: 'Typ dokladu', value: get(pcrIdentificationTypeEnum.find(o => o.id === type), 'label') },
        { label: 'Série', value: series },
        { label: 'Nevalidní od', value: notValidFrom }
      ].map(({ label, value }, key) => (
        <Col md={6} key={key}>
          <Row style={{ margin: '15px 0' }}>
            <Col md={6}>
              <div style={{ fontWeight: 'bold' }}>{label}:</div>
            </Col>
            <Col md={6}>
              <div style={{ textAlign: 'right' }}>{value}</div>
            </Col>
          </Row>
        </Col>
      ))}
    </Row>
  </Card>
);

export const ExternalLookupsForm = ({ lookupItem, closeItem }) => (
  <div>
    <Grid fluid={true}>
      {lookupItem ? <ExternalLookupDetail {...lookupItem} /> : <h4>Žádný doklad nebyl nalezen</h4>}
    </Grid>
    <Button label={'Zavřít'} onClick={closeItem} style={{ margin: '15px' }} />
  </div>
);



// WEBPACK FOOTER //
// ./src/modules/events/ExternalLookupsForm.tsx